import { useContext, useEffect, useState } from "react";

import ListingWeekDayOffer from "../ListingWeekdayOffer";

// assets
import { SvgNavigationArrow } from "assets/icons/js/SvgNavigationArrow";
import { SvgEdit } from "assets/icons/js/SvgEdit";
import { SvgGuest } from "assets/icons/js/SvgGuest";
import { SvgCalendar } from "assets/icons/js/SvgCalendar";
import { ReactComponent as CouponSvg } from "assets/coupon.svg";
import { ReactComponent as Convenience } from "assets/icons/Convenience.svg";
// helpers
import parseHTML from "helpers/parseHTML";
import { formatDate } from "helpers/dateFormatter";
import addCommas from "helpers/addCommasToNumber";

// context
import { ListingInterface } from "context/ListingData";

//scss
import "./style.scss";
import { SvgInfo } from "assets/icons/js/SvgInfo";
import moment from "moment";
import ListingWeekDayOfferGst from "../ListingWeekdayOfferGst";
import { ReactComponent as TaStars } from "../BookingBox/assets/taStars.svg";
import { WeeklyOfferChecker } from "helpers/checkWeekendOffer";
import { AskMeModal } from "components/Booking/AskHelp";
import { useTheme } from "components/ListingNew/ListingTheme";
import { UserContext } from "store";
import { useSearchParams } from "react-router-dom";
const Calculations = ({
	calculations,
	calError,
	calLoading,
	mealRequired,
	handleButtonClick,
	onClose,
	setContent,
	setOpenDrawer,
	dates,
	listingList,
	newDates,
	newCalculations,
	setDates,
	showPet,
	setPetData,
	petData,
}) => {
	const { childrenData, adultsData, roomsData, isFromGoogle } =
		useContext(ListingInterface);

	const checkDiffIn = moment(dates.checkin);
	const checkDiffOut = moment(dates.checkout);
	const dateDiff = Math.abs(checkDiffIn.diff(checkDiffOut, "days"));

	const [isShown, setIsShown] = useState(false);

	const theme = useTheme();

	const [askOpen, setAskOpen] = useState(false);
	const [roomOffer, setRoomOffer] = useState(false);
	const {
		state: { currentUser },
	} = useContext(UserContext);
	const [searchParams, setSearchParams] = useSearchParams();
	useEffect(() => {
		searchParams.set("coupon", calculations?.coupon_code || "");
		setSearchParams(searchParams);
	}, [calculations]);
	return (
		<div className="booking-drawer-content calculations__wrapper">
			<AskMeModal
				open={askOpen}
				setOpen={setAskOpen}
				data={{
					theme: theme,
					LISTING_ID: listingList?.id,
					FROM_DATE:
						Object.keys(calculations).length > 0
							? calculations.FROM_DATE
							: "NA",
					TO_DATE:
						Object.keys(calculations).length > 0 ? calculations.TO_DATE : "NA",
					NO_OF_GUESTS:
						Object.keys(calculations).length > 0
							? calculations.NO_OF_GUESTS
							: listingList?.max_capacity,
					NO_OF_ROOMS:
						Object.keys(calculations).length > 0
							? calculations.NO_OF_ROOMS
							: listingList?.num_similar_rooms,
					TOTAL_AMOUNT_WITH_SERVICE:
						Object.keys(calculations).length > 0
							? calculations.TOTAL_AMOUNT_WITH_SERVICE
							: listingList?.per_night_charge,
					isListing: true,
					isReserveNow: roomOffer ? false : true,
					showLessRoom: roomOffer,
					allowSelectLessRoom: roomOffer,
				}}
			/>
			<div className="booking-date-top">
				<SvgNavigationArrow onClick={onClose} />
				<h3>{parseHTML(listingList?.file_reference?.split("-")[0])}</h3>
			</div>
			{WeeklyOfferChecker(dates.checkin, dates.checkout) && (
				<p
					onClick={() => {
						setRoomOffer(true);
						setAskOpen(true);
					}}
					className=" clr-grey"
					style={{
						fontSize: "12px",
						background: calculations?.discount_amount && "#F3FEF3",
						borderRadius: "4px",
						padding: "4px 0",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						gap: "10px",
						marginBottom: 10,
					}}
				>
					Want to book fewer rooms?{" "}
					<span style={{ cursor: "pointer", textDecoration: "underline" }}>
						Click here
					</span>
				</p>
			)}
			<div className="calculations__content-guest-date">
				<div>
					<h4>Dates</h4>
					<div className="bookingphone-input date">
						<span>
							<SvgCalendar color={"#666666"} />
							<p className="text-xsm-light">
								{dates.checkin && formatDate(dates.checkin)} {"-"}{" "}
								{dates.checkout && formatDate(dates.checkout)}
							</p>
						</span>
						<div
							className="bookingphone-icon icon-date"
							onClick={() => {
								onClose();
								setOpenDrawer(true);
								setContent("dates");
							}}
						>
							<SvgEdit color={"#2368a2"} />
							<p className="text-12px">Edit</p>
						</div>
					</div>
				</div>
				<div>
					<h4>Guests</h4>
					<div className="bookingphone-input guest">
						<span>
							<SvgGuest color={"#666666"} />
							<p>
								{adultsData + childrenData} Guests{" "}
								{listingList?.TYPE_FLAG === "MV"
									? "- " + roomsData
									: listingList?.TYPE_FLAG === "EV"
									? ""
									: "- " + roomsData}
								{listingList?.TYPE_FLAG === "MV"
									? " Villa"
									: listingList?.TYPE_FLAG === "EV"
									? ""
									: " Rooms"}
							</p>
						</span>
						<div
							className="bookingphone-icon icon-guest"
							onClick={() => {
								onClose();
								setOpenDrawer(true);
								setContent("guests");
							}}
						>
							<SvgEdit color={"#2368a2"} />
							<p className="text-12px">Edit</p>
						</div>
					</div>
				</div>
			</div>
			<h4>Price Summary</h4>
			{!isFromGoogle && !calLoading && !calError && (
				<div className="calculations ">
					<div className="con-space-between" style={{ marginTop: "10px" }}>
						<div className="text-xsm-light clr-grey">Room Charges</div>
						<div className="text-xsm clr-black">
							₹
							{addCommas(
								calculations.ROOM_CHARGES + calculations?.TOTAL_SERVICE_CHARGE,
							)}
						</div>
					</div>
					{calculations.MEAL_CHARGES ? (
						<div className="con-space-between">
							<div
								className="text-xsm-light clr-grey"
								style={{ marginTop: "10px" }}
							>
								Meals
							</div>
							<div className="text-xsm clr-black">
								₹{addCommas(calculations.MEAL_CHARGES)}
							</div>
						</div>
					) : null}
					{calculations.EXTRA_CHARGES !== 0 ||
					calculations.TOTAL_BIG_CHILD_CHARGES !== 0 ? (
						<div className="con-space-between" style={{ marginTop: "10px" }}>
							<div className="text-xsm-light clr-grey">
								<p>Extra Guest Charges</p>
								<span
									onMouseEnter={() => setIsShown(true)}
									onMouseLeave={() => setIsShown(false)}
									className="info-icon"
								>
									<SvgInfo />
									{isShown && (
										<div className="info-div">
											{/* {`The base rate is for ${roomsData} rooms at ${
												listingList.CAPACITY
											} people per room,
											anything above that is charged at ${
												calculations.extra_charges +
												calculations.total_big_child_charges
											}rs per adult`} */}
											{`Any booking above ${
												listingList.capacity * roomsData
											} guest will be charged as extra guest.`}
										</div>
									)}
								</span>
							</div>
							<div className="text-xsm clr-black">
								₹
								{addCommas(
									calculations.EXTRA_CHARGES +
										calculations.TOTAL_BIG_CHILD_CHARGES,
								)}
							</div>
						</div>
					) : null}
					{!!calculations.PET_CHARGES && (
						<div className="con-space-between" style={{ marginTop: "10px" }}>
							<div className="text-xsm-light clr-grey">Pet Fee</div>
							<div className="text-xsm clr-black">
								₹{addCommas(calculations.PET_CHARGES)}
							</div>
						</div>
					)}
					<div className="con-space-between" style={{ marginTop: "10px" }}>
						<div className="text-xsm-light clr-grey">GST</div>
						<div className="text-xsm clr-black">
							₹{addCommas(calculations.BOOKING_FEE_SERVICE_TAX_AMOUNT)}
						</div>
					</div>
					{mealRequired && (
						<div className="con-space-between" style={{ marginTop: "10px" }}>
							<div className="text-xsm-light clr-grey">GST Meals</div>
							<div className="text-xsm clr-black">
								₹{addCommas(calculations.service_tax_meal)}
							</div>
						</div>
					)}
					{/* {calculations?.TOTAL_SERVICE_CHARGE === 0 ? (
						<div className="con-space-between" style={{ marginTop: "10px" }}>
							<div className="convenience-text">
								<p>
									<Convenience /> No Convenience Fee
								</p>
							</div>
						</div>
					) : (
						<div className="con-space-between" style={{ marginTop: "10px" }}>
							<div className="text-xsm-light clr-grey">
								Convenience Fee (Incl 18% GST)
							</div>
							<div className="text-xsm clr-black">
								₹{addCommas(calculations.TOTAL_SERVICE_CHARGE)}
							</div>
						</div>
					)} */}
				</div>
			)}
			{currentUser?.isTravelAgent && (
				<div className="ta-commission">
					<div className="con-space-between">
						<div
							style={{
								display: "flex",
								alignItems: "center",
								gap: "6.75px",
							}}
							// className="text-sm-light"
							// style={{ color: theme.primaryTextColor }}
						>
							<TaStars />
							Your Commission
						</div>
						<div
						// className="text-sm-bold"
						// style={{ color: theme.primaryTextColor }}
						>
							₹{addCommas(calculations.TA_COMMISSION)}
						</div>
					</div>
					<div
						style={{
							paddingTop: "5px",
							textAlign: "left",
							fontSize: "12px",
							display: "flex",
							flexDirection: "column",
						}}
					>
						<p>
							{calculations?.TA_COMMISSION === 0 &&
								"Your commission is 0, please make a booking with a larger amount for the commission"}
						</p>
						{/* <p
							style={{
								fontWeight: "700",
							}}
						>
							{calculations?.TA_COMMISSION === 0 &&
							calculations?.coupon_code?.includes("TAC") === false
								? "Add the TA coupon on the booking page"
								: null}
						</p> */}
					</div>
				</div>
			)}

			{!calLoading && !calError && (
				<>
					<div className="dashed-line"></div>
					<div className="con-space-between">
						<div className="text-sm-light">Total Price</div>
						<div className="text-sm-light">
							₹
							{addCommas(
								mealRequired
									? calculations.sub_total
									: isFromGoogle
									? calculations.TOTAL_AMOUNT
									: calculations.TOTAL_AMOUNT_WITH_SERVICE,
							)}
						</div>
					</div>
					{!isFromGoogle && calculations.discount_amount && (
						<div className="con-space-between" style={{ marginTop: "10px" }}>
							<div
								className="text-sm-light"
								style={{
									display: "flex",
									alignItems: "center",
									gap: "8px",
								}}
							>
								<CouponSvg />
								Coupon {`(${calculations?.coupon_code})`}
							</div>
							<div
								className="text-sm-bold"
								style={{
									color: "#11BF0E",
								}}
							>
								- ₹{addCommas(calculations.discount_amount)}
							</div>
						</div>
					)}

					{!isFromGoogle && calculations.discount_amount && (
						<>
							<div className="dashed-line"></div>

							<div className="con-space-between">
								<div className="text-sm-light">You Pay</div>
								<div className="text-sm-bold">
									₹
									{addCommas(
										mealRequired
											? calculations.sub_total
											: calculations.total_amount_with_discount,
									)}
								</div>
							</div>
						</>
					)}
					{/*{dateDiff !== 2 &&*/}
					{/*	newDates.checkin &&*/}
					{/*	newDates.checkout &&*/}
					{/*	calculations.room_charge - newCalculations.room_charge > 0 && (*/}
					{/*		<ListingWeekDayOffer*/}
					{/*			newDates={newDates}*/}
					{/*			calculations={calculations}*/}
					{/*			newCalculations={newCalculations}*/}
					{/*			dates={dates}*/}
					{/*			setDates={setDates}*/}
					{/*		/>*/}
					{/*	)}*/}
					{/*{dateDiff === 2 && (*/}
					{/*	<ListingWeekDayOfferGst dates={dates} setDates={setDates} />*/}
					{/*)}*/}
					{/* <StatusTag color={"#11BF0E"}>
        You are saving ₹{addCommas(2500)}
      </StatusTag> */}
				</>
			)}
			<button aria-label="book-now" className="check-availability">
				<div
					className="text-sm-bold calc-book"
					onClick={() => handleButtonClick()}
				>
					Book Now
				</div>
			</button>
		</div>
	);
};

export default Calculations;
